<button
  *ngFor="let star of stars; index as i"
  [id]="'star_' + i"
  Class="rating-star"
  (click)="countStar(i + 1)"
>
  <mat-icon
    [ngStyle]="{ color: myVariableColor }"
    class="material-icons-outlined"
    >{{ this.rating >= (i + 1) * 70 ? "star" : "star_border" }}</mat-icon
  >
</button>
